<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      d="M6.24998 14.5828H14.5833V12.4995H6.24998V14.5828ZM6.24998 11.4579H18.75V9.37457H6.24998V11.4579ZM6.24998 8.33292H18.75V6.24961H6.24998V8.33292ZM2.08331 22.916V4.16631C2.08331 3.5934 2.28731 3.10296 2.69529 2.69498C3.10328 2.287 3.59373 2.08301 4.16665 2.08301H20.8333C21.4062 2.08301 21.8967 2.287 22.3047 2.69498C22.7127 3.10296 22.9166 3.5934 22.9166 4.16631V16.6661C22.9166 17.239 22.7127 17.7295 22.3047 18.1375C21.8967 18.5454 21.4062 18.7494 20.8333 18.7494H6.24998L2.08331 22.916ZM5.36456 16.6661H20.8333V4.16631H4.16665V17.838L5.36456 16.6661Z"
      fill="currentColor"
    />
  </svg>
</template>
